import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import { Viewer, Worker } from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import React from "react";
import { PlanResource } from "../../data/models/Plan/PlanModel";

import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";

interface ResourceDialogProps {
  open: boolean;
  onClose: () => void;
  resource: PlanResource | null;
}

const ResourceDialog: React.FC<ResourceDialogProps> = ({
  open,
  onClose,
  resource,
}) => {
  if (!resource) return null;

  const defaultLayoutPluginInstance = defaultLayoutPlugin({
    renderToolbar: (Toolbar) => (
      <Toolbar>
        {(slots) => {
          const { Zoom, EnterFullScreen } = slots;

          return (
            <>
              <Zoom />
              <EnterFullScreen />
            </>
          );
        }}
      </Toolbar>
    ),
  });

  const isVideo = resource.resourceType === "VIDEO";

  return (
    <Dialog open={open} onClose={onClose} fullScreen>
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography fontWeight={600}>{resource.title}</Typography>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent
        sx={{
          p: 0,
          height: "85vh",
          bgcolor: "background.default",
        }}
      >
        {isVideo ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
              bgcolor: "black",
            }}
          >
            <video
              src={resource.url}
              controls
              controlsList="nodownload noplaybackrate"
              disablePictureInPicture
              style={{
                maxWidth: "100%",
                maxHeight: "100%",
                objectFit: "contain",
                borderRadius: 8,
              }}
            />
          </Box>
        ) : (
          <Box sx={{ height: "100%", width: "100%" }}>
            <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
              <Viewer
                fileUrl={resource.url}
                plugins={[defaultLayoutPluginInstance]}
              />
            </Worker>
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ResourceDialog;
